import { Stack, Text } from '@chakra-ui/react';
import { AutoComplete, AutoCompleteProps } from './AutoComplete';
import { DateDisplay } from './Date';
import { User } from 'api/bindings/User';
import { getDisplayName } from 'types';
import { WorkOrderSearchRecord } from 'api/bindings/WorkOrderSearchRecord';
import { WorkOrderResponse } from 'api/bindings/WorkOrderResponse';
import { WorkOrder } from 'api/bindings/WorkOrder';
import { PurchaseOrderSearchRecord } from 'api/bindings/PurchaseOrderSearchRecord';
import { PurchaseOrderResponse } from 'api/bindings/PurchaseOrderResponse';
import { AfeCommitmentResponse } from 'api/bindings/AfeCommitmentResponse';
import { AfeSearchRecord } from 'api/bindings/AfeSearchRecord';
import { AfeResponse } from 'api/bindings/AfeResponse';
import { BoardProjectSearchRecord } from 'api/bindings/BoardProjectSearchRecord';
import { BoardProjectResponse } from 'api/bindings/BoardProjectResponse';
import { SubAccountResponse } from 'api/bindings/SubAccountResponse';
import { VendorResponse } from 'api/bindings/VendorResponse';

type OmitProps = 'valueKey' | 'textKey' | 'render';
export type TypedAutoCompleteFieldProps<T> = Omit<
  AutoCompleteProps<T>,
  OmitProps
>;

export const UserAutoComplete = (props: TypedAutoCompleteFieldProps<User>) => {
  return (
    <AutoComplete // valueFn={u => u.id.toString()}
      valueKey={(v) => v.id}
      textKey={getDisplayName}
      placeholder={props.placeholder || 'Select a User'}
      render={(u) => (
        <Stack direction="column" spacing={1}>
          <Text as="i" size="xs">
            {u.email}
          </Text>
        </Stack>
      )}
      {...props}
    />
  );
};

export const WorkOrderAutoComplete = (
  props: TypedAutoCompleteFieldProps<
    WorkOrderSearchRecord | WorkOrderResponse | WorkOrder
  >
) => {
  return (
    <AutoComplete
      valueKey={(v) => v.id}
      textKey={(v) => v.name}
      placeholder={props.placeholder || 'Select a Work Order'}
      render={(wo) => (
        <Stack direction="column" spacing={1}>
          <DateDisplay value={wo.commitmentDate} as="i" size="xs" />
        </Stack>
      )}
      {...props}
    />
  );
};

export const PurchaseOrderAutoComplete = (
  props: TypedAutoCompleteFieldProps<
    PurchaseOrderSearchRecord | PurchaseOrderResponse
  >
) => {
  return (
    <AutoComplete
      valueKey={(v) => v.id}
      textKey={(v) => v.name}
      placeholder={props.placeholder || 'Select a Purchase Order'}
      {...props}
    />
  );
};

export const AfeCommitmentAutoComplete = (
  props: TypedAutoCompleteFieldProps<AfeCommitmentResponse>
) => {
  return (
    <AutoComplete
      valueKey={(v) => v.commitmentId}
      textKey={(v) => v.name}
      placeholder={props.placeholder || 'Select a Commitment'}
      {...props}
    />
  );
};

export const AfeAutoComplete = (
  props: TypedAutoCompleteFieldProps<AfeSearchRecord | AfeResponse>
) => {
  return (
    <AutoComplete
      valueKey={(v) => v.id}
      textKey={(v) => v.name}
      placeholder={props.placeholder || 'Select an AFE'}
      {...props}
    />
  );
};

export const BoardProjectAutoComplete = (
  props: TypedAutoCompleteFieldProps<
    BoardProjectSearchRecord | BoardProjectResponse
  >
) => {
  return (
    <AutoComplete
      valueKey={(v) => v.id}
      textKey={(v) => v.name}
      placeholder={props.placeholder || 'Select a Board Project'}
      {...props}
    />
  );
};

export const SubAccountAutoComplete = (
  props: TypedAutoCompleteFieldProps<SubAccountResponse>
) => {
  return (
    <AutoComplete
      valueKey={(v) => v.subAccountId}
      textKey={(v) => v.fullSubAccountName}
      placeholder={props.placeholder || 'Select an Account'}
      {...props}
    />
  );
};

export const VendorAutoComplete = (
  props: TypedAutoCompleteFieldProps<VendorResponse>
) => {
  return (
    <AutoComplete
      valueKey={(v) => v.id}
      textKey={(v) => v.name}
      placeholder={props.placeholder || 'Select a Vendor'}
      {...props}
    />
  );
};
